const TECHNOPARK_SHORT_NAME_OVERRIDES = {
  "Kütahya Dumlupınar Tasarım Teknoloji Geliştirme Bölgesi": "Kütahya Tasarım Teknokent",
  "Recep Tayyip Erdoğan Üniversitesi ve Türk-Alman Üniversitesi Teknoloji Geliştirme Bölgesi": "Dijitalpark",
  "İstanbul Teknik Üniversitesi Arı Teknokent Teknoloji Geliştirme Bölgesi": "İTÜ ARI Teknokent",
  "ODTÜ TEKNOKENT Teknoloji Geliştirme Bölgesi": "ODTÜ Teknokent",
  "Bilişim Vadisi Teknoloji Geliştirme Bölgesi": "Bilişim Vadisi",
  "Mehmet Akif Ersoy Üniversitesi MAKÜ BAKA Teknoloji Geliştirme Bölgesi": "MAKÜ BAKA Teknokent"
};

const clean = (value) => String(value || "").replace(/\s+/g, " ").trim();

export const getTechnoparkShortName = (technoparkName, savedShortName = "") => {
  const explicitName = clean(savedShortName);
  if (explicitName) return explicitName;

  const fullName = clean(technoparkName);
  if (!fullName) return "";
  if (TECHNOPARK_SHORT_NAME_OVERRIDES[fullName]) {
    return TECHNOPARK_SHORT_NAME_OVERRIDES[fullName];
  }

  const shortenedName = fullName
    .replace(/\s+Teknoloji Geliştirme Bölgesi(?:\s+Sağlık Teknokenti)?$/i, "")
    .replace(/\s+Teknopark$/i, " Teknopark")
    .trim();

  return shortenedName || fullName;
};

